import { DropdownObject } from '@inmoment/the-kitchen';

import { SectionMetadataType } from 'app/providers/storage-api/collection.service';

export class Constants {
  public static readonly SPOTLIGHT_MAX_SHORT_FIELD_DEFAULT_LENGTH = 30;
  public static readonly SPOTLIGHT_MAX_LONG_FIELD_DEFAULT_LENGTH = 64;

  public static readonly DATASOURCE_GROUP_KEY = '--groups--';

  public static readonly TWTRA_ALL_BREAKDOWN = 'All';

  public static readonly TWTRA_DEFAULT_SCORING_STRATEGY = 'AVERAGE';
  public static readonly TWTRA_DEFAULT_DEPENDENT_RANGE = '1:10';
  public static readonly TWTRA_DEFAULT_DRIVERS_RANGE = '1:10';
  public static readonly TWTRA_DEFAULT_BOX_DIRECTION = 'TOP';
  public static readonly TWTRA_DEFAULT_BOX_SIZE = '1';
  public static readonly TWTRA_DEFAULT_MIN_SCALE = '1';
  public static readonly TWTRA_DEFAULT_MAX_SCALE = 10;
  public static readonly TWTRA_DEFAULT_STEP_VALUE = '10%';
  public static readonly TWTRA_DEFAULT_DECIMALS = '1';
  public static readonly TWTRA_DEFAULT_VIEW = 'predictor';
  public static readonly TWTRA_DEFAULT_SCATTER_VALUE = 'Median';
  public static readonly TWTRA_DEFAULT_DISPLAY_LABELS = false;

  public static readonly PREDICTIVE_WIDGET_COMPONENT = 'DashboardWidgetPredictiveComponent';

  public static readonly BLANK = '<blank>';
  public static readonly JOURNEY_TIMELINE_BG = '#eef1f4';

  public static readonly COLLECTION_ICON = 'document_multiple_filled';
  public static readonly COLLECTION_ICON_COLOR = 'green_primary';
  public static readonly GROUP_ICON = 'collections_filled';
  public static readonly GROUP_ICON_COLOR = 'purple_primary';
  public static readonly DYNAMIC_GROUP_ICON = 'app_campaign_insights_filled';
  public static readonly SOCIAL_COLLECTION_ICON = 'research_panel_filled';
  public static readonly SOCIAL_COLLECTION_ICON_COLOR = 'magenta_primary';
  public static readonly DASHBOARD_ICON = 'reporting_filled';
  public static readonly DASHBOARD_ICON_COLOR = 'blue_primary';
  public static readonly ANALYSIS_ICON = 'document_chart_filled';
  public static readonly ANALYSIS_ICON_COLOR = 'orca_primary';

  public static readonly BOX_MIN = 0;
  public static readonly BOX_MAX = 100;
  public static readonly NPS_MIN = -100;
  public static readonly NPS_MAX = 100;

  public static readonly MAX_SECTION_CARDINALITY = 50;
  public static readonly ALL_SECTION_ID = '_all';
  public static readonly SECTION_ALLOWED_ANALYTIC_ITEM_TYPES = [
    'topics',
    'entities',
    'themes',
    'taxonomy',
    'phrases',
  ];
  public static readonly SECTION_PROPERTY_COMPARISON_ALLOWED_WIDGET_TYPES = [
    'impact',
    'documentCount',
  ];

  public static readonly GRID_TOP_N = 200;
  public static readonly GRID_ALLOWED_STANDARD_FIELDS = [
    'tags',
    'creator',
    'language',
    'publisher',
    'source',
    'type',
    'url',
    'locationId',
    'createdAt',
  ];

  public static readonly TRANSPOSED_METADATA_COLUMN = 'fieldId';
  public static readonly NO_BREAKDOWN_VALUE = '__no_breakdown__';
  public static readonly SMART_SUMMARY_MIN_DOC_COUNT_FOR_POINT = 25;
  public static readonly MIN_ALLOWED_CONVERSION_RATE = 20;
  public static readonly ANALYTIC_ITEM_MODAL_DEFAULT_MAX_WIDTH = '800px';
  public static readonly SECTION_PROPERTIES_PREFIX = 'sectionProperties.';
  public static readonly SECTION_ALLOWED_PROPERTY_TYPES = [
    `${this.SECTION_PROPERTIES_PREFIX}segment`,
    `${this.SECTION_PROPERTIES_PREFIX}speakerName`,
    `${this.SECTION_PROPERTIES_PREFIX}speakerType`,
    `${this.SECTION_PROPERTIES_PREFIX}sectionLabel`,
    `${this.SECTION_PROPERTIES_PREFIX}sectionType`,
    `${this.SECTION_PROPERTIES_PREFIX}aliases`,
    `${this.SECTION_PROPERTIES_PREFIX}name`,
  ];
  public static readonly SECTION_PROPERTY_TYPES: Record<string, string> = {
    [`${this.SECTION_PROPERTIES_PREFIX}segment`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}speakerName`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}speakerType`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}sectionLabel`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}sectionTime`]: 'date',
    [`${this.SECTION_PROPERTIES_PREFIX}sectionType`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}aliases`]: 'keyword',
    [`${this.SECTION_PROPERTIES_PREFIX}name`]: 'keyword',
  };
  public static readonly DEFAULT_SECTION_METADATA_TYPE: SectionMetadataType = 'metadata';
  public static readonly SPOTLIGHT_DOWNLOAD_SHOW_WARNING = 'SPOTLIGHT_DOWNLOAD_SHOW_WARNING';
}

//IT = Includes Today
export class RelativeDateConstants {
  public static readonly TODAY = '24hIT';
  public static readonly YESTERDAY = '1d';
  public static readonly LAST_7_DAY = '7d';
  public static readonly LAST_7_DAY_INCLUDE_TODAY = '7dIT';
  public static readonly PREV_7_DAY = 'prev7d';
  public static readonly PREV_7_DAY_INCLUDE_TODAY = 'prev7dIT';
  public static readonly LAST_30_DAY = '30d';
  public static readonly LAST_30_DAY_INCLUDE_TODAY = '30dIT';
  public static readonly PREV_30_DAY = 'prev30d';
  public static readonly PREV_30_DAY_INCLUDE_TODAY = 'prev30dIT';
  public static readonly MONTH_TO_DATE = 'Mtd';
  public static readonly MONTH_TO_DATE_INCLUDE_TODAY = 'MtdIT';
  public static readonly PREV_MONTH = 'prevM';
  public static readonly PREV_YEAR = 'prevY';
  public static readonly YEAR_TO_DATE = 'Ytd';
  public static readonly YEAR_TO_DATE_INCLUDE_TODAY = 'YtdIT';
}

export class ActionPlanConstants {
  public static readonly NOT_STARTED_COLOR = '#7D7D7D';
  public static readonly IN_PROGRESS_COLOR = '#0058FF';
  public static readonly COMPLETED_COLOR = '#00B628';

  public static readonly SELECTABLE_RATING_WIDGET_TYPES = ['breakdown', 'donut'];
}

export class ChartOptionConstants {
  public static readonly BOXDIRECTIONDOS: DropdownObject[] = [
    { title: 'Top', id: 'TOP' },
    { title: 'Bottom', id: 'BOTTOM' },
  ];
  public static readonly TOPBOXSIZEDOS: DropdownObject[] = [
    { title: '1', id: '1' },
    { title: '2', id: '2' },
    { title: '3', id: '3' },
  ];
  public static readonly BOTTOMBOXSIZEDOS: DropdownObject[] = [
    { title: '1', id: '1' },
    { title: '2', id: '2' },
    { title: '3', id: '3' },
    { title: '4', id: '4' },
    { title: '5', id: '5' },
    { title: '6', id: '6' },
    { title: '7', id: '7' },
  ];
  public static readonly DECIMALPRECISIONDOS: DropdownObject[] = [
    { title: '0', id: '0' },
    { title: '1', id: '1' },
    { title: '2', id: '2' },
  ];

  public static readonly DEFAULT_DECIMAL_PRECISION = 2;

  public static readonly MIN_SCALE_DOS: DropdownObject[] = [
    { title: '0', id: '0' },
    { title: '1', id: '1' },
  ];
}

export class FieldConstants {
  public static readonly A_ = 'a_';
  public static readonly CL_ = 'cl_';
  public static readonly MD_ = 'md_';

  public static readonly FILTERTYPES = [
    'project',
    'fieldType',
    'filterable',
    'inUse',
    'containsPII',
    'locked',
    'usedAsIdField',
  ] as const;

  public static readonly GLOBAL = 'GLOBAL';
}

export type AccountFeature =
  | 'LARGE_LANGUAGE_MODELS'
  | 'DRIVER_ANALYSIS'
  | 'SOCIAL_INTEGRATION'
  | 'SPOTLIGHT_AI_ASSISTANT';

export type FilterTypeIDs = (typeof FieldConstants.FILTERTYPES)[number];
